
import { trackPhoneCall } from '@/lib/gtag';
import { Phone, Clock, Shield } from 'lucide-react';

const HeroSection = () => {
  return (
    <section className="relative h-screen flex items-end lg:items-center justify-center overflow-hidden">
      {/* Background Image Optimized for LCP */}
      <div className="absolute inset-0">
        <img
          src="/images/services/desentupimento_profissional.webp"
          srcSet="/images/services/512/desentupimento_profissional.webp 512w, /images/services/1024/desentupimento_profissional.webp 1024w, /images/services/desentupimento_profissional.webp 1536w"
          sizes="100vw"
          alt="Canalizador Urgente em Lisboa"
          className="absolute inset-0 w-full h-full object-cover"
          style={{ objectPosition: 'center center' }}
          loading="eager"
          fetchPriority="high"
          decoding="async"
        />
      </div>
      
      {/* Premium Dark Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t lg:bg-gradient-to-r from-black/80 via-black/50 to-black/25 lg:to-transparent" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12 lg:pb-0">
        <div className="grid lg:grid-cols-12 gap-8 items-center">
          {/* Left Content */}
          <div className="text-white lg:col-span-8 space-y-6">
            {/* Urgent Badge */}
            <div className="inline-flex items-center gap-2 bg-red-600 text-white text-xs sm:text-sm font-bold uppercase tracking-wider px-3.5 py-1.5 rounded-full shadow-lg border border-red-500/30">
              <span className="w-2 h-2 rounded-full bg-white animate-ping" />
              Serviço de Urgência 24h
            </div>

            <h1 className="text-3xl sm:text-5xl lg:text-7xl font-extrabold leading-tight tracking-tight drop-shadow-md">
              Canalizador Urgente <br className="hidden sm:inline" />
              <span className="text-primary-light">em Lisboa</span>
            </h1>

            <p className="text-lg sm:text-2xl text-gray-200 font-medium max-w-2xl drop-shadow">
              Chegamos em 30 minutos, serviço garantido!
            </p>

            {/* Visual reassurance list */}
            <div className="grid sm:grid-cols-2 gap-3 max-w-xl pt-2">
              <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm p-3 rounded-lg border border-white/10">
                <Clock className="w-5 h-5 text-logo-green flex-shrink-0" />
                <span className="text-sm font-semibold">Resposta rápida em 30 min</span>
              </div>
              <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm p-3 rounded-lg border border-white/10">
                <Shield className="w-5 h-5 text-logo-green flex-shrink-0" />
                <span className="text-sm font-semibold">Garantia total de serviço</span>
              </div>
            </div>

            <div className="pt-4 flex flex-wrap gap-4">
              <a
                href="tel:+351960488777"
                className="bg-primary hover:bg-primary-dark text-white font-bold py-4 px-8 rounded-xl transition-all duration-300 inline-flex items-center gap-3 hover:scale-105 shadow-xl text-lg group"
                onClick={() => trackPhoneCall('+351960488777')}
              >
                <Phone className="w-6 h-6 animate-pulse" />
                <span>Pedir um Orçamento</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;

